import { createApp, defineAsyncComponent, resolveComponent } from 'vue/dist/vue.esm-bundler';
import { Swiper, SwiperSlide } from "swiper/vue";
import { Navigation, Pagination } from "swiper";
import Vue3StickySidebar from "vue3-sticky-sidebar";
import { computed } from 'vue';
//import { qq }  from './components/HeaderComponent.vue'
const vueApp = createApp({
  comments: true,
  setup() {
    return {
      modules: [Navigation, Pagination],
    };
  },
  computed: {
    isMobile() {
      return  window.innerWidth < 768;
    }
  },
  methods: {
    gtmEvent(event_name, title = null, url = null) {
      const baseEvent = {
        event: 'DLevent',
        eventName: event_name
      };

      let eventData;

      if (title && url) {
        eventData = {
          ParameterName1: 'button_name',
          ParameterValue1: title,
          ParameterName2: 'button URL',
          ParameterValue2: url
        };
      } else {
        eventData = {
          ParameterName1: 'click',
          ParameterValue1: 'click'
        };
      }

      dataLayer.push({ ...baseEvent, ...eventData });
    }
  }
});

const filesCommon = require.context('./components', true, /\.vue$/i);

vueApp.config.compilerOptions.comments = true;

filesCommon.keys().map(key =>
  vueApp.component(
      key
      .split('/')
      .pop()
      .split('.')[0],
      filesCommon(key).default,
      {
        comments: true,
      }
  )
);

vueApp.directive('class-toggler', {
  mounted(el, { modifiers: { parent, closest, prevent }, arg, value }) {
    el.clickCallback = (e) => {
      // v-class-toggler.prevent="'some-class'"
      if (prevent) {
        e.preventDefault();
      }
      let target;
      switch (true) {
        // v-class-toggler.parent="'some-class'"
        case parent:
          target = el.parentNode;
          break;
        // v-class-toggler:closest-el-class.closest="'some-class'"
        case closest:
          target = arg ? el.closest(`.${arg}`) : el;
          break;
        // v-class-toggler="'some-class'"
        default:
          target = el;
      }
      if (!target) {
        return;
      }

      target.classList.toggle(value);
    };
    el.addEventListener('click', el.clickCallback);
  },
  unmounted(el) {
    el.addEventListener('click', el.clickCallback);
  },
});

vueApp.directive('click-outside', {
  beforeMount(el, binding) {
    el.clickOutsideEvent = function(event) {
      if (!(el === event.target || el.contains(event.target))) {
        binding.value(event);
      }
    };
    document.addEventListener('click', el.clickOutsideEvent);
  },
  beforeUnmount(el) {
    document.removeEventListener('click', el.clickOutsideEvent);
  }
});

const instance = vueApp
  .component('Swiper', Swiper)
  .component('SwiperSlide', SwiperSlide)
  .component('Vue3StickySidebar', Vue3StickySidebar)
  .mount("#app");


export { instance };
